import { Flex, Text } from '@mantine/core';

export const InfoItem = ({
  icon,
  text,
  secondText,
  textColor,
  customText,
  align = 'center',
}: {
  icon: JSX.Element;
  text?: string | JSX.Element;
  secondText?: string;
  textColor?: string;
  customText?: JSX.Element;
  align?: 'center' | 'flex-start';
}) => (
  <Flex gap="15px" align={align} c={textColor}>
    {icon}
    <Flex direction="column">
      {customText}
      <Text w="100%" size="14px" lh="18px">
        {text}
      </Text>
      {secondText && (
        <Text w="100%" size="14px" lh="18px">
          {secondText}
        </Text>
      )}
    </Flex>
  </Flex>
);
